import { createAction } from 'redux-actions'
// @ts-ignore
import { createRequestActions as request } from 'store/actionCreators'

export const fetchLibrariesLevels = request('GENERATOR/FETCH_LIBRARIES_LEVELS', () => ({
  request: {
    url: '/protracks-libraries-levels',
  },
}))

// @ts-ignore
export const fetchCategoriesTagsForCurrentLibraryLevel = request('GENERATOR/FETCH_CATEGORIES_TAGS_FOR_CURRENT_LIBRARY_LEVEL', (
    { proTrackLibraryId, numberOfDays }: { numberOfDays: number, proTrackLibraryId: string }
  ) => ({
  request: {
    url: `/protracks-libraries-levels/${proTrackLibraryId}/${numberOfDays}`,
  }
}))

export const generateActivitiesByCategoriesTags = createAction('GENERATOR/GENERATE_ACTIVITIES_BY_CATEGORIES_TAGS', (categoriesTags: any) => {
  return categoriesTags;
})

export const clearCategoriesTagsWithActivities = createAction('GENERATOR/CLEAR_CATEGORIES_TAGS_WITH_ACTIVITIES', () => {})

export const replaceActivity = createAction('GENERATOR/REPLACE_ACTIVITY', ({ activityForReplace, replacedActivityId }: {
  activityForReplace: any, replacedActivityId: number
}) => {
  return { activityForReplace, replacedActivityId };
})
